import 'ui-theme/plugins/slide/js/slide';

(function (UX) {
    UX.slide.setBackLabel = function () {
        let icon = 'icon-arrow_left';
        if (UX.slide.$toggle.data('icon')) {
            icon = UX.slide.$toggle.data('icon');
        }
        UX.slide.$back.html(`<i class="${icon}" aria-hidden="true"></i>`);
    };
})(UX);
